import { render, staticRenderFns } from "./TOTPField.vue?vue&type=template&id=acfb9a98"
import script from "./TOTPField.vue?vue&type=script&lang=js"
export * from "./TOTPField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports